import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FAQ() {
  const faqs = [
    {
      q: 'Hoobuy é seguro para comprar?',
      a: 'Sim, a Hoobuy é completamente segura. A plataforma oferece inspeção de produtos com fotos reais antes do envio, proteção ao comprador em caso de problemas e diversas opções de pagamento seguro. Milhares de compradores no Brasil e em Portugal utilizam a plataforma diariamente com total confiança.',
    },
    {
      q: 'Como funciona a Hoobuy Spreadsheet?',
      a: 'A Hoobuy Spreadsheet é uma planilha organizada com mais de 10.000 produtos selecionados e verificados. Nela você encontra links diretos para produtos organizados por categoria como tênis, roupas, hoodies, jaquetas, acessórios e muito mais. Basta escolher o produto, copiar o link e adicionar ao carrinho na plataforma Hoobuy.',
    },
    {
      q: 'O que é uma Hoobuy Spreadsheet?',
      a: 'Uma Hoobuy Spreadsheet (planilha Hoobuy) é uma coleção curada de links de produtos disponíveis na plataforma Hoobuy. Ela reúne os melhores produtos verificados pela comunidade, organizados por categorias, facilitando muito a busca e economizando horas de pesquisa. É a ferramenta essencial para quem quer comprar na Hoobuy de forma eficiente.',
    },
    {
      q: 'Qual é o melhor agente chinês para compras?',
      a: 'A Hoobuy se destaca como um dos melhores agentes chineses disponíveis atualmente. Comparada com outros agentes como CNFans e Pandabuy, a Hoobuy oferece mais de 10.000 produtos, inspeção gratuita com fotos reais, frete rápido e suporte ao cliente 24 horas. Nossa Hoobuy Spreadsheet facilita ainda mais a experiência de compra.',
    },
    {
      q: 'Posso comprar no Brasil usando a Hoobuy?',
      a: 'Sim, você pode comprar no Brasil usando a Hoobuy sem problemas. A plataforma oferece envio internacional para o Brasil e Portugal com diversas opções de frete. Utilize nossa Hoobuy Spreadsheet para encontrar os melhores produtos com links verificados e atualizados, facilitando todo o processo de compra internacional.',
    },
    {
      q: 'Os links da planilha são atualizados com que frequência?',
      a: 'Os links da nossa Hoobuy Spreadsheet são verificados e atualizados diariamente. Nossa equipe monitora constantemente a disponibilidade dos produtos, remove links quebrados e adiciona novos produtos populares. Isso garante que você sempre tenha acesso aos melhores produtos disponíveis na plataforma Hoobuy.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            Perguntas Frequentes
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Tire suas dúvidas sobre a Hoobuy Spreadsheet e a plataforma Hoobuy.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(i)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">{faq.q}</span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${openIndex === i ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-400'}`}>
                  <i className={`text-xs transition-transform duration-300 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/artigo/hoobuy-spreadsheet-guia"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors"
          >
            Leia o Guia Completo da Hoobuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <script type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': faqs.map((faq) => ({
              '@type': 'Question',
              'name': faq.q,
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}